import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RruleDateComponent } from './rrule-date.component';
import { SharedModule } from 'app/shared/shared.module';



@NgModule({
  declarations: [
    RruleDateComponent
  ],
  imports: [
    SharedModule,
    CommonModule
  ],
  exports: [
    RruleDateComponent
  ]
})
export class RruleDateModule { }
